import React, { useState } from 'react';
import { addDoc, collection } from 'firebase/firestore';
import { Link, useNavigate } from 'react-router-dom';
import { BsCheck2Circle } from 'react-icons/bs';
import { MdOutlineSmsFailed } from 'react-icons/md';
import { FaAnglesLeft } from 'react-icons/fa6';
import { db, storage } from '../../../firebase';
import Modal from '../../../components/Modal/Modal';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import { BiXCircle } from 'react-icons/bi';

const AddAuthor = () => {
    const navigate = useNavigate();
    const [displayName, setDisplayName] = useState('');
    const [profilPicture, setProfilPicture] = useState('');

    const [isLoading, setIsLoading] = useState(false);
    const [open, setOpen] = useState(false);
    const [isSent, setIsSent] = useState(false);

    const handleCover = (event) => {
        const file = event.target.files[0];
        if (file) {
            setProfilPicture({
                file,
                preview: URL.createObjectURL(file)
            });
        }
    };

    const removeCover = () => {
        setProfilPicture(null);
    };

    const handleAddAuthor = async (e) => {
        setIsLoading(true);
        e.preventDefault();

        try {
            if (!profilPicture || !profilPicture.file) throw new Error("Aucune photo sélectionnée");

            // Générer un nom personnalisé pour le fichier
            const timestamp = Date.now();
            const extension = profilPicture.file.name.split('.').pop();
            const safeDisplayName = displayName.replace(/\s+/g, '_').toLowerCase();
            const customName = `author_${safeDisplayName}_${timestamp}.${extension}`;

            // Créer une référence avec ce nom
            const fileRef = ref(storage, `authors_profil_pictures/${customName}`);

            // Upload
            await uploadBytes(fileRef, profilPicture.file);

            // Récupérer l'URL
            const profilPictureUrl = await getDownloadURL(fileRef);

            // Enregistrer l’auteur dans Firestore
            await addDoc(collection(db, "authors"), {
                displayName: displayName,
                profilPicture: profilPictureUrl,
                createdAt: new Date(),
            });

            // Reset UI
            setIsSent(true);
            setIsLoading(false);
            setOpen(true);
            setDisplayName("");
            setProfilPicture(null);
        } catch (error) {
            console.error("Erreur lors de l'ajout de l'auteur :", error.message);
            setIsSent(false);
            setIsLoading(false);
            setOpen(true);
        }
    };

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <section className="bg-black flex flex-col gap-[30px] px-[60px] w-full">
            <p className="font-agrandir xl:text-[24px] text-[16px] text-tangerine">Utilisateurs</p>

            <div className="xl:flex hidden justify-start items-center">
                <Link onClick={() => navigate(-1)} className="font-pressura flex items-center text-aqua text-[14px]">
                    <FaAnglesLeft className='text-[10px]' />
                    Back
                </Link>
            </div>

            <div className='flex flex-col items-center justify-center'>
                <p className='font-bold text-violet'>Ajouter un auteur</p>

                <form onSubmit={handleAddAuthor} className='flex flex-col gap-5'>
                    <label className='text-white'>
                        Nom complet:
                        <input
                            className='outline-none border-2 text-black px-4 py-2 rounded-md w-full font-agrandir'
                            type="text" value={displayName} onChange={(e) => setDisplayName(e.target.value)} required />
                    </label>

                    <div className="my-10">
                        <label className='text-white'>Photo de profil</label>

                        <div className="relative border-2 border-dashed border-gray-300 rounded-lg p-6 text-center cursor-pointer hover:border-purple-500 transition-all">
                            <input
                                type="file"
                                onChange={handleCover}
                                accept="image/*"
                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                            />
                            <p className="text-gray-500">Cliquez ou glissez une image ici</p>
                        </div>

                        {/* Preview de la cover */}
                        {profilPicture && (
                            <div className="relative mt-4 w-full max-w-md mx-auto">
                                <img
                                    src={profilPicture.preview}
                                    alt="Cover preview"
                                    className="w-full rounded-lg shadow-lg object-cover"
                                />
                                <button
                                    onClick={removeCover}
                                    className="absolute top-2 right-2 bg-red-500 text-white p-1.5 rounded-full shadow-lg hover:bg-red-600 transition"
                                >
                                    <BiXCircle size={20} />
                                </button>
                            </div>
                        )}
                    </div>


                    <div className="flex w-full justify-center items-center pt-10">
                        <button className="buttonviolet w-[100px!important]">
                            {isLoading ? (
                                <svg className="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            ) : (
                                <p>Ajouter</p>
                            )}
                        </button>
                    </div>

                </form>
            </div>

            {open &&
                <Modal isOpen={open} onClose={handleClose}>
                    <center>
                        <div className='flex flex-col gap-4 items-center justify-center'>

                            {isSent ? (
                                <>
                                    <BsCheck2Circle className='text-green-700 text-[50px]' />

                                    <p>Nouvel auteur ajouté !</p>
                                </>
                            ) : (
                                <>
                                    <MdOutlineSmsFailed className='text-red-700 text-[50px]' />

                                    <p>Une erreur s'est produite, veuillez réessayer !</p>
                                </>
                            )}

                            <button
                                className='buttonviolet'
                                type='submit'
                                onClick={handleClose}
                            >OK</button>

                        </div>
                    </center>
                </Modal>
            }

        </section>
    )
}

export default AddAuthor